import React, { useCallback, useEffect, useState } from "react";
import { CONFIG } from "../../environment";
import { NumericFormat } from "react-number-format";
import { Button, DatePicker, Form, Input, Modal, Select } from "antd";
import { useNavigate } from "react-router-dom";
import AuthService from "../../services/auth.service";
import dayjs from "dayjs";
import moment from "moment";
import { useTranslation } from "react-i18next";
import ProfileService from "../../services/profile.service";
import {
  allowOnlyAlphaNumerics,
  allowOnlyAlphaNumericsWithSpecialChar,
} from "../../services/common.service";

import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";

export default function SelfUnlock({ data = {}, setData, setCurrentStep }) {
  const navigate = useNavigate();
  const [verifyDetails, setVerifyDetails] = useState({});
  const [formDetails, setFormDetails] = useState({});
  const [successVisible, setSuccessVisible] = useState(false);
  const [message, setMessage] = useState("");
  const { t } = useTranslation();
  const [dataSource, setDataSource] = useState([]);
  const [avilableOption, setAvailableOptions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);

  const defaultPickerValue = selectedDate
    ? selectedDate
    : dayjs().subtract(18, "years");

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  useEffect(() => {
    getQestionsAndAnswer();
  }, []);

  const getQestionsAndAnswer = useCallback(async () => {
    try {
      const response = await ProfileService.getSecurityQuestions();
      if (response.status === 200) {
        setDataSource(response.data["data"]["securityList"] || []);
      }
    } catch (error) {}
  }, []);

  useEffect(() => {
    const initialOptions = dataSource.map((option) => option.question);
    setAvailableOptions([...initialOptions]);
  }, [dataSource]);

  const handleQuestionChange = useCallback(
    (questionIndex, selectedQuestion) => {
      setSelectedQuestions((prevSelectedQuestions) => {
        const updatedQuestions = [...prevSelectedQuestions];
        const previousQuestion = updatedQuestions[questionIndex];
        if (previousQuestion) {
          setAvailableOptions((prevAvailableOptions) => [
            ...prevAvailableOptions,
            previousQuestion,
          ]);
        }
        setAvailableOptions((prevAvailableOptions) =>
          prevAvailableOptions.filter((option) => option !== selectedQuestion)
        );
        updatedQuestions[questionIndex] = selectedQuestion;
        return updatedQuestions.filter(Boolean);
      });
    },
    []
  );

  const onVerify = useCallback(async (values) => {
    try {
      const reqParams = {
        mobileNo: values.mobileNo.slice(-CONFIG?.MOBILE_NO_LENGTH),
        userName: values.userName,
        customerDob: dayjs(values.dob).format("YYYY-MM-DD"),
        securityQuestions: [
          {
            question: values.question1,
            answer: values.answer1,
          },
          // {
          //   question: values.question2,
          //   answer: values.answer2,
          // },
        ],
      };
      setFormDetails(reqParams);
      const response = await AuthService.selfUnLockVerify(reqParams);
      if (response.status === 200) {
        if (response.data["otpEnabled"]) {
          setData({
            ...reqParams,
            ...response.data,
          });
          setCurrentStep(1);
          setVerifyDetails(response.data);
        } else {
          setVerifyDetails(response.data);
          await onConfirm({ ...reqParams, otp: CONFIG?.DEFAULT_OTP });
        }
      }
    } catch (error) {}
  }, []);

  const onConfirm = useCallback(async (values) => {
    try {
      const reqParams = {
        ...values,
      };
      const response = await AuthService.selfUnLockConfirm(reqParams);
      if (response.status === 200) {
        setMessage(response.data["message"]);
        setSuccessVisible(true);
      }
    } catch (error) {}
  }, []);

  return (
    <>
      <div className="row justify-content-center">
        <div className="">
          <Form layout="vertical" onFinish={onVerify}>
            <div style={{ position: "relative" }}>
              <Form.Item
                label={t("pages.login.userName", {
                  defaultValue: "Username",
                })}
                name="userName"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.userName_required", {
                      defaultValue: "Username is required",
                    }),
                  },
                ]}
              >
                <Input
                  maxLength={20}
                  size="large"
                  placeholder={t("pages.login.userName", {
                    defaultValue: "Username",
                  })}
                  onKeyPress={(e) => allowOnlyAlphaNumericsWithSpecialChar(e)}
                />
              </Form.Item>
            </div>
            <div className="row">
              <div className="mobileNoStyle col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("common.mobile_number", {
                    defaultValue: "Mobile Number",
                  })}
                  name="mobileNo"
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.mobile_no_requir", {
                        defaultValue: "Mobile Number is required",
                      }),
                    },
                  ]}
                >
                  <NumericFormat
                    maxLength={15}
                    placeholder={t("common.mobile_number", {
                      defaultValue: "Mobile Number",
                    })}
                    allowNegative={false}
                    customInput={Input}
                    size="large"
                  />
                </Form.Item>
              </div>
              <div style={{ position: "relative" }} className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("pages.forgotPassword.date_of_birth", {
                    defaultValue: "Date of Birth",
                  })}
                  name="dob"
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.date_of_birth_required", {
                        defaultValue: "Date Of Birth is required",
                      }),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder="DD-MM-YYYY"
                    format={{
                      format: "DD-MM-YYYY",
                      type: "mask",
                    }}
                    className="col-12"
                    style={{ borderRadius: "5px" }}
                    size="large"
                    value={selectedDate}
                    onChange={handleDateChange}
                    defaultPickerValue={defaultPickerValue}
                    disabledDate={(current) =>
                      current.isAfter(moment().subtract(18, "years"))
                    }
                    showNow={false}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="mt-1">
              <Form.Item
                label={t("pages.security_questions.security_questions1", {
                  defaultValue: "Security Question 1",
                })}
                name="question1"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.security_qus_1", {
                      defaultValue: "Security Question is required",
                    }),
                  },
                ]}
              >
                <Select
                  placeholder={t("pages.security_questions.security_questions1", {
                    defaultValue: "Security Question",
                  })}
                  size="large"
                  onChange={(value) => {
                    handleQuestionChange(0, value);
                  }}
                >
                  {avilableOption.map((option, idx) => (
                    <Select.Option key={idx} value={option}>
                      {option}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label=""
                name="answer1"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.answer_require", {
                      defaultValue: "Answer is required",
                    }),
                  },
                ]}
              >
                <Input
                  onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                  placeholder={t("pages.security_questions.answer", {
                    defaultValue: "Answer",
                  })}
                  maxLength={20}
                  size="large"
                />
              </Form.Item>
            </div>
            {/* <div className="mt-3">
              <Form.Item
                label={t("pages.security_questions.security_question2", {
                  defaultValue: "Security Question 2",
                })}
                name="question2"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.security_qus_2", {
                      defaultValue: "Security Question 2 is required",
                    }),
                  },
                ]}
              >
                <Select
                  placeholder={t("pages.security_questions.security_question2", {
                    defaultValue: "Security Question 2",
                  })}
                  size="large"
                  onChange={(value) => {
                    handleQuestionChange(1, value);
                  }}
                >
                  {avilableOption.map((option, idx) => (
                    <Select.Option key={idx} value={option}>
                      {option}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label=""
                name="answer2"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.answer_require", {
                      defaultValue: "Answer is required",
                    }),
                  },
                ]}
              >
                <Input
                  onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                  placeholder={t("pages.security_questions.answer", {
                    defaultValue: "Answer",
                  })}
                  maxLength={20}
                  size="large"
                />
              </Form.Item>
            </div> */}
            <div align="center">
              <Button
                className="login-button mt-2"
                block
                size="large"
                type="primary"
                htmlType="submit"
              >
                {t("buttons.submit_btn", {
                  defaultValue: "Submit",
                })}
              </Button>
            </div>
          </Form>
        </div>
      </div>

      <Modal
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center" className="mt-4">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 100 }}
              onClick={() => {
                navigate("/login");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
